import { render, staticRenderFns } from "./AuthorizeModal.vue?vue&type=template&id=166cc8a9"
import script from "./AuthorizeModal.vue?vue&type=script&lang=js"
export * from "./AuthorizeModal.vue?vue&type=script&lang=js"
import style0 from "./AuthorizeModal.vue?vue&type=style&index=0&id=166cc8a9&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports